<template>
  <div class="default-layout">
    <DesignSystemNotificationSection top-size="small" />
    <div class="main-content">
      <slot />
    </div>
  </div>
</template>

<style lang="scss" scoped>
.default-layout {
  display: flex;
  flex-direction: column;
  min-height: 100vh;
}
.main-content {
  flex: 1;
  display: flex;
  flex-direction: column;
}
</style>
